export const titleLogin = "관리자 로그인";

export const msgIdMust = "아이디를 입력해 주세요";
export const msgIdMin = "5자 이상 입력하셔야 합니다";
export const msgIdRule = "허용하지 않는 문자를 입력하셨습니다";

export const msgPwdMust = "비밀번호를 입력해 주세요";
export const msgPwdMin = "8자 이상 입력하셔야 합니다";
export const msgPwdRule = "특수문자는 @, $, !, %, *, #, ?, &만 입력할 수 있습니다";

export const saveId = "아이디 저장";

export const id = "아이디";
export const idPlaceholder = "아이디를 입력해 주세요.";
export const password = "패스워드";
export const passwordPlaceholder = "비밀번호를 입력해 주세요.";
export const login = "로그인";
export const logout = "로그아웃";
export const phone = "전화번호";
export const email = "이메일";

export const unavailable = "비활성화";
export const title = "제목";
export const attachment = "첨부파일";
export const number = "번호";

export const search = "검색";
export const filter = "필터";
export const reset = "초기화";
export const close = "닫기";
export const register = "등록";
export const remove = "삭제";

// Menu
export const titleDashboard = "대시보드";
export const titleUsers = "통합회원 관리";
export const titleSell = "판매 관리";

export const titleCar = "차량 관리";
export const titleSelledCar = "판매 차량 관리";
export const titleRentCar = "렌트 차량 관리";
export const titleRegisterCar = "Ruta40 차량 등록";

export const titleOrder = "주문 관리";
export const titleCustomer = "고객지원 관리";
export const titleReferenceRoom = "자료실 관리";
export const titleMedias = "미디어 관리";
export const titleNotice = "공지/이벤트 관리";
export const titleSellMedias = "판매 차량 미디어 관리";
export const titleRentMedias = "렌트 차량 미디어 관리";
export const titleRentNotice = "렌트 차량 공지/이벤트 관리";
export const titleRentStatistics = "렌트 통계";
export const titleRentB2b = "B2B 관리";
export const titleRentPeakSeason = "성수기 관리";

export const titleRent = "렌트 관리";
export const titleReservation = "예약 관리";
export const titleCoupon = "쿠폰 관리";
export const titleInformation = "주요안내 관리";
export const titleQuestions = "자주하는질문 관리";
export const titleManuals = "매뉴얼 관리";
export const titleRentReview = "이용 후기 관리";

export const titleDigitalKey = "디지털 키 관리";

export const titleEvent = "행사 관리";
export const titleCampingfair2023 = "2023 캠핑대전";
export const titleSurveys = "사전판매 설문 조사";
export const titleCampingCarShow = "2023 캠핑카쇼";
export const titleAutoSalon2023 = "2023 오토살롱위크";
export const titleCampnicFair2024 = "2024 캠프닉페어";
export const titleGreenCamp2024 = "2024 고창별밤 그린캠프 (취소)";
export const titleCampingfair2024 = "2024 캠핑대전";
export const titleCampingfair2025 = "2025 캠핑대전";

export const titleCustomerServiceCenter = "고객센터";
export const titleCounseling = "상담 리스트";
export const titleTextNotice = "문자 안내_공지";
export const titleTextRelease = "문자 안내_출차";

export const titleSetup = "시스템 설정";

export const titleOrders = "주문 현황";
export const titleCarCategories = "분류 관리";
export const titleCarModels = "모델 관리";
export const titleCarTypes = "타입 관리";
export const titleOrderColors = "색상 관리";
export const titleOrderOptions = "옵션 관리";
export const titleCatalogs = "카탈로그 관리";
export const titleFaqs = "FAQ 관리";
export const titleInformationTitles = "주제 관리";
export const titleInformationSubtitles = "부제 관리";
export const titleVisitor = "방문자 현황";

export const titleCampingfairEvent = "캠핑대전 이벤트";

export const userEmail = "이메일";
export const userName = "이름";
export const userCompanyName = "회사명";
export const userPhone = "휴대전화번호";
export const userAddress = "주소";
export const userAddressDetails = "상세주소";
export const userType = "타입";
export const userAuthority = "권한";
export const userStatus = "계정상태";

export const userAdd = "추가";
export const userUpdate = "수정";
export const userRemove = "삭제";

export const carCategoryId = "카테고리 ID";
export const carCategoryName = "카테고리 이름";

export const carModelId = "모델 ID";
export const carModelName = "모델 이름";

export const carTypeId = "타입 ID";
export const carTypeName = "타입 이름";
export const carTypePrice = "타입 가격";

export const optionId = "옵션 ID";
export const optionName = "옵션 이름";
export const optionPrice = "옵션 가격";

export const surveyQuestionNo = "설문조사 번호";
export const surveyQuestion = "설문조사 질문";
export const surveyQuestionSummary = "설문조사 요약";
export const answerNo = "설문조사 답변 번호";
export const answer = "설문조사 답변";
export const surveyDisabled = "비활성화";

export const colorId = "색상 ID";
export const colorName = "색상 이름";

export const manualId = "매뉴얼 ID";
export const manualVersion = "매뉴얼 버젼";
export const manualName = "매뉴얼 이름";
export const manualFileName = "매뉴얼 파일 이름";

export const catalogId = "카탈로그 ID";
export const catalogVersion = "카탈로그 버젼";
export const catalogName = "카탈로그 이름";
export const catalogFileName = "카탈로그 파일 이름";

export const noticeId = "공지사항 ID";
export const noticeWriter = "작성자";
export const noticeFiles = "공지사항 파일";
export const noticeTitle = "제목";
export const noticeContents = "내용";
export const noticeFileId = "공지사항 파일 ID";
export const noticeFileName = "공지사항 파일 이름";
export const noticeFileDeleted = "공지사항 파일 삭제";
export const fixed = "고정";
export const hits = "조회수";
export const registeredDate = "등록일";

export const faqId = "FAQ ID";
export const faqQuestion = "FAQ 질문";
export const faqAnswer = "FAQ 답변";
export const faqOrder = "순서";

export const informationTitleId = "주요 안내 주제 ID";
export const informationTitle = "주요 안내 주제";
export const informationSubtitleId = "주요 안내 부제 ID";
export const informationSubtitle = "주요 안내 부제";
export const informationContent = "주요 안내 내용";

export const mediaId = "미디어 ID";
export const mediaTitle = "미디어 제목";
export const mediaUrl = "미디어 URL";
export const mediaCopyright = "미디어 출처";
export const mediaWriter = "미디어 글쓴이";

export const dash = "-";
export const paymentDeposit = "예약금";
export const paymentDownPayment = "계약금";
export const paymentSubsiby = "보조금";
export const paymentBalance = "잔금";
export const paymentAdditionalDownPayment = "개조비용 계약금";
export const paymentAdditionalBalance = "개조비용 잔금";
export const paymentRegistrationFee = "구조변경 등록비";

export const prev = "이전";
export const save = "저장";
export const update = "수정";
export const add = "등록";

export const rent = "차량대여";
export const delayed_return = "반납지연";
export const vehicle_damage = "차량파손";
export const rent_item_damage = "기물파손";
export const rent_item_loss = "기물분실";
export const insurance = "보험";
export const penalty = "규정 위반";
export const additional_item = "비품추가";
export const electric_charge = "충전비용";

export const online = "카드결제(온라인)";
export const offline_card = "카드결제(현장)";
export const offline_bank = "계좌이체(현장)";
export const offline_cash = "현금결제(현장)";

export const count_car = "대";
export const totalRentCarCount = "렌트 차량 수";
export const totalActiveRentCarCount = "운영 차량 수";
export const totalRepairingRentCarCount = "점검 차량 수";
export const totalWaitingRentCarCount = "대기 차량 수";

export const rent_use = "출차";
export const rent_return = "반납";

export const msg_admin_must = "관리자만 이용할 수 있습니다.";

export const count_user = "명";
export const total_user_count = "누적 가입자 수";
export const today_user_count = "오늘 신규 가입자 수";
export const total_visitor_count = "총 방문자 수";
export const today_visitor_count = "오늘 방문자 수";

/* 색상 */
export const color = "색상";
export const msgInputName = "이름을 입력해 주세요.";

export const name = "이름";
export const ID = "ID";
export const updateSuccess = "수정 성공";
export const updateError = "수정 실패";
export const removeSuccsee = "삭제 성공";
export const removeError = "삭제 실패";
export const addSuccess = "등록 성공";
export const addError = "등록 실패";

export const msgUpdateSuccess = "수정을(를) 완료했습니다.";
export const msgRemoveSuccess = "삭제을(를) 완료했습니다.";
export const msgAddSuccess = "등록을(를) 완료했습니다.";
